import { render, staticRenderFns } from "./BlogRightSideBarPage.vue?vue&type=template&id=12b1cbfd&"
import script from "./BlogRightSideBarPage.vue?vue&type=script&lang=js&"
export * from "./BlogRightSideBarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports